import { getGroups, getGroupsKey } from "../api/getGroups";

import { useGetFriendlyUrl } from "utils/hooks/useGetFriendlyUrl";

import { useReactQuery } from "components/RemoteData";

export const useGetGroups = () => {
  const { friendlyUrl } = useGetFriendlyUrl();
  return useReactQuery(getGroupsKey(), () => getGroups(friendlyUrl));
};
